function getAccountId() {
  const user = JSON.parse(sessionStorage.getItem("user"));
  return user?.id;
}

angular.module('bizmetryApp').controller('ImportResourcesTypesDialogController', function (
  $scope, $mdDialog, $http, CONFIG, templateData, template_id, resource_types, TemplateInstanceService, $mdToast, DatasourceService
) {
  const accountId = getAccountId();

  if (!accountId) {
    console.error("Account ID not found in sessionStorage.");
    $mdDialog.cancel();
    return;
  }

  $scope.datasources = [];
  $scope.schemas = [];
  $scope.entities = [];

  $scope.resource_owners = Array.isArray(templateData)
    ? templateData.sort((a, b) => a.name.localeCompare(b.name))
    : [];

  $scope.selectedDomain = null;
  $scope.selectedDatasourceId = null;
  $scope.selectedDatasource = null;
  $scope.selectedSchema = null;

  $scope.cancel = function () {
    $mdDialog.cancel();
  };

  // ============================================
  // Check if there are online datasources
  // ============================================
  $scope.hasOnlineDatasources = function () {
    return $scope.datasources && $scope.datasources.length > 0;
  };

  $scope.hasSelectedEntities = function () {
    return $scope.entities.some(e => e.selected);
  };

  $scope.confirmImport = function () {
    const selectedEntities = $scope.entities.filter(e => e.selected);

    if (!$scope.selectedDomain) {
      alert('Please select a domain for the imported resources.');
      return;
    }

    if (selectedEntities.length === 0) {
      alert('Please select at least one entity to import.');
      return;
    }

    const entitiesMissingAttributes = selectedEntities.filter(e => !Array.isArray(e.attributes));
    if (entitiesMissingAttributes.length > 0) {
      alert("Some selected entities have no attributes loaded. Please deselect or click on them to load.");
      return;
    }

    const payload = {
      datasource_id: $scope.selectedDatasource?.id,
      datasource_name: $scope.selectedDatasource?.datasourceName,
      schema_name: $scope.selectedSchema,
      domain_id: $scope.selectedDomain.id,
      domain_name: $scope.selectedDomain.name,

      resource_owner: {
        id: $scope.selectedDomain.id,
        name: $scope.selectedDomain.name,
        description: $scope.selectedDomain.description,
        enabled: $scope.selectedDomain.enabled
      },

      resource_types: selectedEntities.map(entity => ({
        name: entity.tableName,

        resource_owner: {
          id: $scope.selectedDomain.id,
          name: $scope.selectedDomain.name,
          description: $scope.selectedDomain.description,
          enabled: $scope.selectedDomain.enabled
        },

        attributes: entity.attributes.map(attr => ({
          name: attr.columnName,
          type: attr.dataType,
          length: attr.columnSize != null ? attr.columnSize.toString() : null,
          isPrimaryKey: attr.isPrimaryKey,
          // Deterministic candidates: the import's fallback when IntelliSense can't answer
          isResourceNameField: !!attr.isResourceNameField,
          isResourceDescriptionField: !!attr.isResourceDescriptionField,
          jsonSchema: attr.jsonSchema,
          enumValues: attr.enumValues,
          jsonSample: attr.jsonSample
        }))
      }))
    };

    console.log('📤 Sending import payload with resource_owner:', payload);

    // The backend asks IntelliSense (SchemaSense) for PK / RN / RD and descriptions of every entity
    $scope.importing = true;
    TemplateInstanceService.importResourceTypes(template_id, payload)
      .then(response => {
        // ✅ CAPTURAR EL TEMPLATE ACTUALIZADO
        console.log('✅ Import successful, updated template received:', response);

        $mdToast.show(
          $mdToast.simple()
            .textContent('✅ Resources imported successfully')
            .position('bottom right')
            .hideDelay(3000)
        );

        // ✅ CERRAR EL DIÁLOGO Y PASAR EL TEMPLATE ACTUALIZADO
        $mdDialog.hide(response);
      })
      .catch(err => {
        console.error("❌ Failed to import resource Types", err);
        $mdToast.show(
          $mdToast.simple()
            .textContent('❌ Failed to import resource Types')
            .position('bottom right')
            .toastClass('error-toast')
            .hideDelay(4000)
        );
      })
      .finally(() => {
        $scope.importing = false;
      });
  };

  $scope.onDatasourceChange = function () {
    const selectedId = $scope.selectedDatasourceId;
    $scope.selectedDatasource = $scope.datasources.find(ds => ds.id === selectedId);

    if (!$scope.selectedDatasource) {
      console.warn("Datasource not found");
      return;
    }

    $scope.schemas = [];
    $scope.entities = [];
    $scope.selectedSchema = null;

    DatasourceService.getSchemas(selectedId)
      .then(data => $scope.schemas = data)
      .catch(err => console.error('Error loading schemas', err));
  };

  $scope.onSchemaChange = function () {
    $scope.entities = [];

    if (!$scope.selectedDatasourceId || !$scope.selectedSchema) {
      console.warn("Schema or datasource missing");
      return;
    }

    const existingNames = [];
    try {
      if (Array.isArray(resource_types)) {
        existingNames.push(...resource_types.map(rt => rt.name.toLowerCase()));
      }
    } catch (e) {
      console.warn("⚠️ Error extracting existing resource_types:", e);
    }

    DatasourceService.getEntities($scope.selectedDatasourceId, $scope.selectedSchema)
      .then(data => {
        if (!Array.isArray(data)) {
          console.error("Unexpected response format for entities:", data);
          return;
        }

        $scope.entities = data.map(entity => {
          const isDuplicate = existingNames.includes(entity.tableName.toLowerCase());
          return {
            ...entity,
            selected: false,
            disabled: isDuplicate,
            showTooltip: false
          };
        });
      })
      .catch(err => console.error('Error loading entities:', err));
  };

  $scope.$watch('selectedSchema', function (newSchema) {
    if (newSchema) {
      console.log("🟢 Schema changed & domain already selected → cargar entidades");
      $scope.onSchemaChange();
    }
  });

  $scope.selectedDomainId = null;
  $scope.selectedDomain = null;

  $scope.onDomainSelected = function () {
    $scope.selectedDomain = $scope.resource_owners.find(o => o.id === $scope.selectedDomainId);
    console.log("✅ selectedDomain =", $scope.selectedDomain);
  };

  // ============================================
  // ✅ Cargar Datasources al inicio (SOLO ONLINE)
  // ============================================
  DatasourceService.getDatasources(accountId)
    .then(data => {
      // ✅ FILTRAR SOLO DATASOURCES ONLINE
      $scope.datasources = data.filter(ds => ds.isOnline);
      console.log('✅ Online datasources loaded:', $scope.datasources.length);

      if ($scope.datasources.length === 0) {
        console.warn('⚠️ No online datasources available');
        // No auto-select nada si no hay datasources
        return;
      }

      if ($scope.datasources.length > 0) {
        $scope.selectedDatasourceId = $scope.datasources[0].id;
        $scope.onDatasourceChange();
      }
    })
    .catch(err => {
      console.error('❌ Error loading datasources:', err);
      $mdToast.show(
        $mdToast.simple()
          .textContent('Error loading datasources')
          .position('top right')
          .hideDelay(3000)
      );
    });

  $scope.loadAttributes = function (entity) {
    if (entity.attributes || entity.loadingAttributes) return;

    entity.loadingAttributes = true;

    DatasourceService.getAttributes($scope.selectedDatasourceId, $scope.selectedSchema, entity.tableName)
      .then(data => {
        entity.attributes = data;
        entity.loadingAttributes = false;
      })
      .catch(err => {
        console.error(`❌ Error loading attributes for ${entity.tableName}:`, err);
        entity.attributes = [];
        entity.loadingAttributes = false;
      });
  };

  $scope.toggleTooltip = function ($event, entity) {
    $event.stopPropagation();
    $event.preventDefault();

    console.log("🔵 toggleTooltip called for:", entity.tableName, "current state:", entity.showTooltip);

    $scope.entities.forEach(e => {
      if (e !== entity) {
        e.showTooltip = false;
      }
    });

    entity.showTooltip = !entity.showTooltip;

    console.log("🟢 New tooltip state:", entity.showTooltip);

    if (!entity.showTooltip) return;

    const trigger = $event.currentTarget;
    const triggerRect = trigger.getBoundingClientRect();
    const dialog = document.querySelector('.import-resource-dialog');
    const dialogRect = dialog.getBoundingClientRect();

    const offsetTop = triggerRect.bottom - dialogRect.top + 6;
    const offsetLeft = triggerRect.left - dialogRect.left;
    const tooltipMaxHeight = 300;
    const dialogHeight = dialogRect.height;

    let top = offsetTop;
    if (dialogHeight - offsetTop < tooltipMaxHeight + 20) {
      top = triggerRect.top - dialogRect.top - tooltipMaxHeight - 6;
    }

    let left = offsetLeft;
    const maxLeft = dialogRect.width - 380;
    if (left > maxLeft) left = maxLeft;
    if (left < 0) left = 10;

    entity.tooltipPosition = {
      position: 'absolute',
      top: `${top}px`,
      left: `${left}px`,
      'z-index': 1000,
      'max-height': `${tooltipMaxHeight}px`,
      'overflow-y': 'auto'
    };

    if (!entity.attributes && !entity.loadingAttributes) {
      $scope.loadAttributes(entity);
    }
  };

  $scope.closeAllTooltips = function () {
    $scope.entities.forEach(e => e.showTooltip = false);
  };

  const documentClickHandler = function (event) {
    if (event.target.closest('.modern-tooltip') ||
      event.target.closest('.md-icon-button[aria-label="View details"]')) {
      console.log("🔵 Click dentro de tooltip o botón info - ignorando");
      return;
    }

    console.log("🔴 Click fuera - cerrando tooltips");
    $scope.$apply(() => {
      $scope.closeAllTooltips();
    });
  };

  document.addEventListener('click', documentClickHandler);

  $scope.$on('$destroy', function () {
    document.removeEventListener('click', documentClickHandler);
  });

  $scope.existingResourceTypeNames = [];

  try {
    const json = templateData?.template_json;
    if (json && Array.isArray(json.resource_types)) {
      $scope.existingResourceTypeNames = json.resource_types.map(rt => rt.name.toLowerCase());
    }
  } catch (e) {
    console.warn("⚠️ Failed to extract resource_types from template", e);
  }

  $scope.onEntitySelectionChange = function (entity) {
    if (entity.selected && !Array.isArray(entity.attributes)) {
      $scope.loadAttributes(entity);
    }
  };
});